<template>
<div>
  <v-app-bar app
    :clipped-left="$vuetify.breakpoint.xsOnly"
    :dense="$vuetify.breakpoint.xsOnly"
    color="primary"
    class="kobe-app-bar"
    elevate-on-scroll
  >
    <v-app-bar-nav-icon
      @click.stop="$emit('openDrawer')"
      v-if="$vuetify.breakpoint.xsOnly"></v-app-bar-nav-icon>

    <v-toolbar-title :class="{'pl-0': $vuetify.breakpoint.xsOnly}" v-if="$vuetify.breakpoint.xsOnly">
      <div class="toolbar-logo-wrap">
        <img :src="logoPrimary" alt="Logo" />
      </div>
    </v-toolbar-title>

    <v-spacer v-if="$vuetify.breakpoint.xsOnly"></v-spacer>

    <v-toolbar-title>{{routerName}}</v-toolbar-title>

    <v-spacer></v-spacer>

    <!-- <v-text-field
      class="blue-input"
      label="Search..."
      hide-details
      color="primary"
    /> -->
    <v-menu
      bottom
      origin="center center"
      transition="scale-transition"
      v-if="showActivePlatform"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          v-on="on"
        >
          <v-icon v-if="showActivePlatform.icon" class="pt-1" small>{{showActivePlatform.icon}}</v-icon>
          <img :src="showActivePlatform.imgIcon" width="20px" v-if="showActivePlatform.imgIcon" />&nbsp;{{ showActivePlatform.handle }} <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="(obj, i) in userPlatforms"
          :key="i"
          link
          @click="changePlatform(obj)"
        >
          <v-list-item-title>
            <v-icon v-if="obj.icon">{{obj.icon}}</v-icon>
            <img :src="obj.imgIcon" width="20px" v-if="obj.imgIcon" /> {{ obj.handle }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-menu
      v-model="profileMenu"
      :close-on-content-click="false"
      :nudge-width="370"
      offset-x
    >
      <template v-slot:activator="{ on }">
        <v-avatar style="cursor: pointer" icon v-on="on" size="40">
            <img :src="activeUser.avatar"/>
        </v-avatar>
      </template>
      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-avatar size="75" style="margin-left: 15px">
              <v-img
                v-bind:src="activeUser.avatar"
                alt="User Profile Image"
                @click="changeProfilePicture"
              >
              </v-img>
              <!-- <span><v-icon @click="changeProfilePicture" size="15">mdi-pencil</v-icon></span> -->
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{activeUser.displayName}}</v-list-item-title>
              <v-list-item-subtitle>{{activeUser.role}}<br>{{activeUser.email}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="secondary" text
          @click="updateNewPassword"
          >Change Password</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="logout">Logout</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>

    <!-- <div class="navbar-custom-menu">
      <ul class="nav navbar-nav">
        <li class="nav-item dropdown user user-menu">
          <a
            href="javascript:;"
            class="nav-link dropdown-toggle"
            id="navbarDropdown"
            data-toggle="dropdown"
          >
            <img v-bind:src="activeUser.avatar" class="user-image" alt="User Image" />
          </a>
          <ul class="dropdown-menu">
            <li class="user-header">
              <img
                v-bind:src="activeUser.avatar"
                class="img-circle change-img"
                alt="User Image"
                data-toggle="modal"
                :data-target="changeAvatarModalIdDisplay"
              />
              <div class="p-image" data-toggle="modal" :data-target="changeAvatarModalIdDisplay">
                <i class="fa fa-camera upload-button"></i>
              </div>
              <p>
                {{activeUser.displayName}} - {{activeUser.role}}
                <small>{{activeUser.email}}</small>
              </p>
            </li>

            <li class="user-footer">
              <div class="pull-left">
                <a
                  href="#"
                  data-toggle="modal"
                  :data-target="changePasswordModalIdDisplay"
                  class="btn btn-default btn-flat"
                >Change Password</a>
              </div>
              <div class="pull-right">
                <a href="#" @click.prevent="logout" class="btn btn-default btn-flat">Sign out</a>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div> -->
  </v-app-bar>
    <change-avatar-modal v-model="changeAvatarDialog" :value="changeAvatarDialog" @changeAvatar="uploadAvatar"></change-avatar-modal>
    <change-password-modal v-model="passwordModalDialog" :value="passwordModalDialog" @changePassword="passwordChanged"></change-password-modal>
</div>
</template>

<script>
import { mapState } from 'vuex'
import config from '@/config'
import moment from 'moment'
import ChangeAvatarModal from '../ChangeAvatarModal'
import ChangePasswordModal from '../views/User/ChangePasswordModal'
import userAPIs from '../views/User/userAPIs';
export default {
  name: 'CoreToolbar',
  props: [
    'drawer'
  ],
  components: {
    ChangeAvatarModal,
    ChangePasswordModal
  },
  data() {
    return {
      changeAvatarDialog: false,
      passwordModalDialog: false,
      profileMenu: false,
      changePasswordModalId: 'changePasswordModalId',
      logoPrimary: require('@/assets/Kobe Logo Blue.png')
    }
  },
  watch: {
    $route (to, from) {
      this.getUserProfile()
    }
  },
  computed: {
    currentUserID: function() {
      return this.$store.state.user.id;
    },
    routerName() {
      if (this.$route.name === 'co-dashboard') {
        return 'CC Dashboard'
      } else if (this.$route.name === 'am-dashboard') {
        return 'AM Dashboard'
      } else if (this.$route.name === 'co-speed') {
        return 'Speed'
      } else if (this.$route.name === 'am-speed') {
        return 'Speed'
      } else if (this.$route.name === 'am-spend-revenue') {
        return 'Revenue'
      } else if (this.$route.name === 'co-spend-revenue') {
        return 'Revenue'
      } else if (this.$route.name === 'am-spend-campaign-report') {
        return 'Campaign Report'
      } else if (this.$route.name === 'co-spend-campaign-report') {
        return 'Campaign Report'
      } else {
        return this.$route.name
      }
    },
    ...mapState(['userInfo', 'user', 'userPlatforms', 'showActivePlatform']),
    activeUser() {
      return {
        displayName: this.user.firstName + ' ' + this.user.lastName,
        avatar: this.user.profilePicture ? this.user.profilePicture : '/static/img/avatar/user.png',
        email: this.user.email,
        createdAt: moment(this.user.createdAt).format('MMM D, YYYY'),
        role: config['userRolesDetails'][this.user.role]['display']
      };
    },
    changePasswordModalIdDisplay: function() {
      return `#${this.changePasswordModalId}`
    },
    currentUserRole: function () {
      return Number(this.$store.state.user.role)
    },
    facebookId: function() {
      return this.$store.state.user.facebookId;
    }
  },
  mounted() {
    this.getUserProfile()
  },
  methods: {
    updateNewPassword() {
      this.passwordModalDialog = true;
    },
    changeProfilePicture() {
      this.changeAvatarDialog = true;
    },
    uploadAvatar(path) {
      this.$store.commit('SET_AVATAR', path)
      this.changeAvatarDialog = false;
      this.$swal({
        title: 'Success',
        text: 'Your avatar is updated.',
        type: 'success'
      })
    },
    changeloading() {
      this.$store.commit('TOGGLE_SEARCHING')
    },
    passwordChanged() {
      this.passwordModalDialog = false;
      this.$swal({
        title: 'Success',
        text: 'Your password has been changed. Please login again!',
        type: 'success'
      }).then(() => {
        this.logout()
      })
    },
    logout() {
      // Dispatch event from store
      this.$store.dispatch('LOG_OUT')
      this.$store.commit('REMOVE_ACTIVE_PLATFORM')

      // Redirect to home page
      this.$router.push({ name: 'Login' })
    },
    async changePlatform(data) {
      await this.$store.dispatch('influencer/update', {
        id: this.user.influencerID,
        activePlatform: data.platform
      })
      let user = JSON.parse(window.localStorage.getItem('user'))
      user.activePlatform = data.platform
      window.localStorage.setItem('user', JSON.stringify(user))
      window.location.reload()
    },
    async getUserProfile() {
      if (this.currentUserRole !== config.userRoles.INFLUENCER) {
        return
      }
      userAPIs
        .getUser(this.currentUserID)
        .then(async (response) => {
          const influencer = response.influencer
          if (!influencer) return

          this.$store.commit('SET_USER_PLATFORMS', influencer)
          const resolvedPlatform = this.$store.state.activePlatform
          const storedPlatform = String(influencer.activePlatform || '').toLowerCase() === 'x'
            ? 'twitter'
            : String(influencer.activePlatform || '').toLowerCase()
          if (resolvedPlatform && resolvedPlatform !== storedPlatform) {
            await this.$store.dispatch('influencer/update', {
              id: influencer.id,
              activePlatform: resolvedPlatform
            })
          }

          // handle for non registered influencers
          const hasPlatform = influencer.instagram || influencer.tiktok || influencer.youtube ||
            influencer.xiaohongshu || influencer.facebook || influencer.linkedin || influencer.twitter ||
            influencer.reqIgHandle || influencer.reqTikTokHandle || influencer.reqYoutubeHandle || influencer.reqLinkedinHandle
          if (!hasPlatform) {
            this.$router.push({path: '/profile'})
            // if (this.$route.name === 'Profile') {
            //   this.$swal({
            //     title: '<strong>Warning!</strong>',
            //     text: 'No Accounts Connected. Please connect to instagram',
            //     type: 'warning',
            //     confirmButtonText: 'Connect <i class="fa fa-instagram"></i>',
            //     cancelButtonText: `Don't Have Instagram`,
            //     showCancelButton: true,
            //     allowOutsideClick: () => false,
            //     onClose: () => {
            //       this.$router.push({path: '/profile'})
            //     }
            //   }).then((result) => {
            //     if (result.value) {
            //       this.connectInstagram()
            //     }
            //   });
            // } else {
            //   this.$router.push({path: '/profile'})
            // }
          }
        })
    },
    connectInstagram () {
      let reqObj = {
        client_id: config.INSTAGRAM_CLIENT_ID,
        redirect_uri: config.INSTAGRAM_LOGIN_REDIRECT_URL,
        scope: 'instagram_business_basic',
        response_type: 'code'
      }
      reqObj = Object.keys(reqObj)
      .map(key => `${key}=${reqObj[key]}`)
      .join('&')
      window.location.href = config.INSTAGRAM_APP_AUTHORIZE_URL + '?' + reqObj
    }
  }
};
</script>

<style scoped>
.kobe-app-bar {
  color: var(--ims-color-secondary);
}

.toolbar-logo-wrap {
  width: 84px;
  max-width: 100%;
  line-height: 0;
}

.toolbar-logo-wrap img {
  display: block;
  width: 100%;
  height: auto;
}
</style>

<style>
</style>



// WEBPACK FOOTER //
// Toolbar.vue?36a0a7d2